import { render } from "./HelpDrawer.vue?vue&type=template&id=c45f27a2&scoped=true"
import script from "./HelpDrawer.vue?vue&type=script&lang=js"
export * from "./HelpDrawer.vue?vue&type=script&lang=js"

import "./HelpDrawer.vue?vue&type=style&index=0&id=c45f27a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c45f27a2"]])

export default __exports__